import dayjs from '@/common/lib/dayjs';
import { MergedClub } from '@/common/types/api.interfaces';
import { ExtensionVerificationForm } from '@/common/utils/formFields';

export const DEFAULT_MEMBER_VERIFICATION_VALUES = {
  [ExtensionVerificationForm.HomeClub]: null,
  [ExtensionVerificationForm.DateOfBirth]: '',
  [ExtensionVerificationForm.MembershipNumber]: '',
};

export const validationRules = (translations: Record<string, string>) => ({
  club: {
    required: translations['extensionflow.memberverification.fieldrequired'],
  },
  membershipNumber: {
    required: translations['extensionflow.memberverification.fieldrequired'],
  },
  dateOfBirth: {
    required: translations['extensionflow.memberverification.fieldrequired'],
    validate: (value: string) => {
      const age = dayjs().diff(dayjs(value), 'year');
      return age >= 18 || translations['extensionflow.memberverification.minimumageerror'];
    },
  },
});

export const mapClubsToGroupedOptions = (clubs: MergedClub[]) => {
  return clubs
    .map((club) => ({
      studioName: club.studioName,
      clubId: club.clubId,
      city: club.address.city,
      countryCode: club.address.countryCodeAlpha2,
    }))
    .sort((a, b) => {
      // Sort by city to prevent duplicate headers in Autocomplete groupBy
      if (a.city < b.city) return -1;
      if (a.city > b.city) return 1;
      return 0;
    });
};
